import React, { useState, useEffect } from 'react';
import SupplyChainContract from '../../contracts/SupplyChainContract.js';

const AdminPage = () => {
  const [userAddressRegister, setUserAddressRegister] = useState('');
  const [userNameRegister, setUserNameRegister] = useState('');
  const [userRoleRegister, setUserRoleRegister] = useState('');

  const [userAddressRevoke, setUserAddressRevoke] = useState('');
  const [registeredUsers, setRegisteredUsers] = useState([]);

  useEffect(() => {
    const fetchRegisteredUsers = async () => {
      try {
        const userCount = await SupplyChainContract.methods.getUserCount().call();

        if (!userCount || isNaN(userCount)) {
          console.error('Invalid user count:', userCount);
          return;
        }

        const users = [];
        for (let i = 0; i < userCount; i++) {
          const userAddress = await SupplyChainContract.methods.getUserAddressByIndex(i).call();

          if (!userAddress) {
            console.error('Invalid user address at index', i, ':', userAddress);
            continue;
          }

          const userRolesResult = await SupplyChainContract.methods.getUserRoles(userAddress).call();

          const address = userRolesResult[0];
          const role = userRolesResult[1];
          const name = userRolesResult[2];

          if (!address || !role || !name) {
            console.error('Invalid user roles for address', userAddress, ':', { address, role, name });
            continue;
          }

          users.push({ address, role, name });
        }

        setRegisteredUsers(users);
      } catch (error) {
        console.error('Error fetching registered users:', error);
      }
    };

    fetchRegisteredUsers();
  }, []);

  const getRoleString = (role) => {
    switch (role) {
      case '0':
        return 'Meat Processor';
      case '1':
        return 'Inspector';
      case '2':
        return 'Distributor';
      case '3':
        return 'Retailer';
      default:
        return 'Unknown Role';
    }
  };

  const handleUserAddressRegisterChange = (e) => {
    setUserAddressRegister(e.target.value);
  };

  const handleUserNameRegisterChange = (e) => {
    setUserNameRegister(e.target.value);
  };

  const handleUserRoleRegisterChange = (e) => {
    setUserRoleRegister(e.target.value);
  };

  const handleUserAddressRevokeChange = (e) => {
    setUserAddressRevoke(e.target.value);
  };

  const handleRegisterUserRole = async () => {
    try {
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      const adminAddress = accounts[0];

      const lowercaseUserAddress = userAddressRegister.toLowerCase();

      const receipt = await SupplyChainContract.methods
        .registerUserRole(lowercaseUserAddress, userRoleRegister, userNameRegister)
        .send({ from: adminAddress });

      if (receipt.status) {
        const updatedUsers = await SupplyChainContract.methods.getUserCount().call();
        const users = [];
        for (let i = 0; i < updatedUsers; i++) {
          const userAddress = await SupplyChainContract.methods.getUserAddressByIndex(i).call();
          const userRolesResult = await SupplyChainContract.methods.getUserRoles(userAddress).call();
          const address = userRolesResult[0];
          const role = userRolesResult[1];
          const name = userRolesResult[2];

          if (!address || !role || !name) {
            console.error('Invalid user roles for address', userAddress, ':', { address, role, name });
            continue;
          }

          users.push({ address, role, name });
        }
        setRegisteredUsers(users);
      } else {
        console.error('Transaction failed. See console for details.');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleRevokeUserRole = async (userAddress) => {
    try {
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      const adminAddress = accounts[0];

      if (!userAddress) {
        console.error('Invalid user address for revocation:', userAddress);
        return;
      }

      const receipt = await SupplyChainContract.methods.revokeUserRole(userAddress.toLowerCase()).send({ from: adminAddress });

      if (receipt.status) {
        const updatedUsers = await SupplyChainContract.methods.getUserCount().call();
        const users = [];
        for (let i = 0; i < updatedUsers; i++) {
          const userAddress = await SupplyChainContract.methods.getUserAddressByIndex(i).call();
          const userRolesResult = await SupplyChainContract.methods.getUserRoles(userAddress).call();
          const address = userRolesResult[0];
          const role = userRolesResult[1];
          const name = userRolesResult[2];

          if (!address || !role || !name) {
            console.error('Invalid user roles for address', userAddress, ':', { address, role, name });
            continue;
          }

          users.push({ address, role, name });
        }
        setRegisteredUsers(users);
      } else {
        console.error('Transaction failed. See console for details.');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="container mx-auto p-8 pt-16 ">

      {/* Register User Role Section */}
      <div className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Register User Role</h2>
        <div className="flex items-center mb-4">
          <label className="mr-4">User Address:</label>
          <input type="text" value={userAddressRegister} onChange={handleUserAddressRegisterChange} className="border p-2" />
        </div>
        <div className="flex items-center mb-4">
          <label className="mr-4">User Name:</label>
          <input type="text" value={userNameRegister} onChange={handleUserNameRegisterChange} className="border p-2" />
        </div>
        <div className="flex items-center mb-4">
          <label className="mr-4">User Role:</label>
          <select value={userRoleRegister} onChange={handleUserRoleRegisterChange} className="border p-2">
            <option value="0">Meat Processor</option>
            <option value="1">Inspector</option>
            <option value="2">Distributor</option>
            <option value="3">Retailer</option>
          </select>
        </div>
        <button onClick={handleRegisterUserRole} className="bg-blue-500 text-white px-4 py-2 rounded">Register User Role</button>
      </div>

      {/* Revoke User Role Section */}
      <div className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Revoke User Role</h2>
        <div className="flex items-center mb-4">
          <label className="mr-4">User Address:</label>
          <input type="text" value={userAddressRevoke} onChange={handleUserAddressRevokeChange} className="border p-2" />
        </div>
        <button onClick={() => handleRevokeUserRole(userAddressRevoke)} className="bg-red-500 text-white px-4 py-2 rounded">Revoke User Role</button>
      </div>

      {/* Registered Users Tables */}
      <div>
        <h2 className="text-2xl font-semibold mb-4">Registered Users</h2>

        {/* Meat Processor Table */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold mb-4">Meat Processor</h3>
          <table className="w-full border">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">User Name</th>
                <th className="border p-2">User Role</th>
                <th className="border p-2">User Address</th>
                <th className="border p-2">Revoke Role</th>
              </tr>
            </thead>
            <tbody>
              {registeredUsers
                .filter((user) => user.role === '0')
                .map((user, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : ''}>
                    <td className="border p-2 text-center">{user.name}</td>
                    <td className="border p-2 text-center">{getRoleString(user.role)}</td>
                    <td className="border p-2 text-center">{user.address}</td>
                    <td className="border p-2 text-center">
                      <button onClick={() => handleRevokeUserRole(user.address)} className="bg-red-500 text-white px-4 py-2 rounded">Revoke Role</button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>



        {/* Inspector Table */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold mb-4">Inspector</h3>
          <table className="w-full border">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">User Name</th>
                <th className="border p-2">User Role</th>
                <th className="border p-2">User Address</th>
                <th className="border p-2">Revoke Role</th>
              </tr>
            </thead>
            <tbody>
              {registeredUsers
                .filter((user) => user.role === '1')
                .map((user, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : ''}>
                    <td className="border p-2 text-center">{user.name}</td>
                    <td className="border p-2 text-center">{getRoleString(user.role)}</td>
                    <td className="border p-2 text-center">{user.address}</td>
                    <td className="border p-2 text-center">
                      <button onClick={() => handleRevokeUserRole(user.address)} className="bg-red-500 text-white px-4 py-2 rounded">Revoke Role</button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {/* Distributor Table */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold mb-4">Distributor</h3>
          <table className="w-full border">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">User Name</th>
                <th className="border p-2">User Role</th>
                <th className="border p-2">User Address</th>
                <th className="border p-2">Revoke Role</th>
              </tr>
            </thead>
            <tbody>
              {registeredUsers
                .filter((user) => user.role === '2')
                .map((user, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : ''}>
                    <td className="border p-2 text-center">{user.name}</td>
                    <td className="border p-2 text-center">{getRoleString(user.role)}</td>
                    <td className="border p-2 text-center">{user.address}</td>
                    <td className="border p-2 text-center">
                      <button onClick={() => handleRevokeUserRole(user.address)} className="bg-red-500 text-white px-4 py-2 rounded">Revoke Role</button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {/* Retailer Table */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Retailer</h3>
          <table className="w-full border">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">User Name</th>
                <th className="border p-2">User Role</th>
                <th className="border p-2">User Address</th>
                <th className="border p-2">Revoke Role</th>
              </tr>
            </thead>
            <tbody>
              {registeredUsers
                .filter((user) => user.role === '3')
                .map((user, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : ''}>
                    <td className="border p-2 text-center">{user.name}</td>
                    <td className="border p-2 text-center">{getRoleString(user.role)}</td>
                    <td className="border p-2 text-center">{user.address}</td>
                    <td className="border p-2 text-center">
                      <button onClick={() => handleRevokeUserRole(user.address)} className="bg-red-500 text-white px-4 py-2 rounded">Revoke Role</button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default AdminPage;
